<template>
  <form @submit.prevent="$emit('submit', student)">
    <h3>{{ title }}</h3>

    <label for="name" class="form__label">Name</label>
    <input
      type="text"
      id="name"
      class="form__input"
      v-model="student.name"
    />

    <GradePicker v-model="student.grade" />

    <div class="student-form__footer">
      <button type="button" class="button button--border button--cancel" @click.prevent="$emit('cancel')">Cancel</button>
      <button type="submit" class="form__submit">Save Student</button>
    </div>
  </form>
</template>

<script>
import GradePicker from '@/components/GradePicker'

export default {
  name: 'StudentForm',

  components: {
    GradePicker
  },

  props: {
    title: {
      type: String,
      default: 'Add a New Student'
    },

    student: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.student-form__footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  button {
    margin-left: 1rem;
  }
}
</style>
